import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import AircraftLogbookMaintenanceOperationalRestrictionTable from './AircraftLogbookMaintenanceOperationalRestrictionTable';

// Importo o moment com a linguagem pt-br
require('moment');
require('moment/locale/pt-br');

class AircraftLogbookMaintenanceOperationalRestrictionTab extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          overlay: {
            message: '',
            type: '',
            status: 'closed',
          },
          redirect_url: false,
          loaded: 0,
          action_parts_modal: false,
          aircraft_logbook_id: {},
          aircraft_logbook_report_id: '',
          report_action_id: '',
          overload_analysis_str: '',
          correlation_analysis_str: '',
          limit_date_str: '',
          approval_date_str: '',
          status_str: '',
          reports: {},
          aircraft_logbook_deferred_items: {},
          report_action_parts_replacements: [],
          aircraft_logbook_reports_list: [],
          users_list: [],
          bases_list: [],
          approvals_reports: [],
        };
      }


      // LM
      componentWillReceiveProps(newProps) {
        // Atualiza sempre que receber novas props, garantindo que os ACRs sejam carregados
        const nextState = {};

        if (typeof newProps.aircraft_logbook_id !== 'undefined') {
          nextState.aircraft_logbook_id = newProps.aircraft_logbook_id;
        }

        if (typeof newProps.aircraft_logbook_deferred_items !== 'undefined' && newProps.aircraft_logbook_deferred_items !== null) {
          nextState.aircraft_logbook_deferred_items = newProps.aircraft_logbook_deferred_items;
        }

        if (Object.keys(nextState).length > 0) {
          nextState.loaded = 1;
          this.setState(nextState);
        }
      }
    
      render() {
        var self = this;
        return (
      <div>
      <RequestApi ref={'request_api'} />
        <h3 className="page-title pull-left">Deferred Items</h3>
        <div className="clearfix"></div>
        <hr/>
        <div className="table-responsive">
          <table className="table table-bordered table-hover table-striped">
            <caption>Deferred Items</caption>
            <thead>
              <tr>
                <th className="text-center vcenter" width="100">Item Number</th>
                <th className="text-center vcenter" width="100">MEL</th>
                <th className="text-center vcenter" width="100">Category</th>
                <th className="text-center vcenter" width="100">Type</th>
                <th className="text-center vcenter" width="100">Limit Type</th>
                <th className="text-center vcenter" width="100">Limit</th>
                <th className="text-center vcenter" width="100">Limit Date</th>
                <th className="text-center vcenter" width="100">Limit Hour</th>
                <th className="text-center vcenter" width="100">Limit Landing</th>
                <th className="text-center vcenter" width="100">Description</th>
                <th className="text-center vcenter" width="100">Reason</th>
                <th className="text-center vcenter" width="100">Correlation Analysis</th>
                <th className="text-center vcenter" width="150">Overload Analysis</th>
                <th className="text-center vcenter" width="100">Status</th>
                <th className="text-center vcenter" width="100">Captain</th>
                <th className="text-center vcenter" width="100">Acceptance Date</th>
                <th className="text-center vcenter" width="100">Action</th>
              </tr>
            </thead>
            <tbody id="report_actions">
            {Object.keys(self.state.aircraft_logbook_deferred_items).map(function(k) {
              var report_action = self.state.aircraft_logbook_deferred_items[k];
              return(
                <AircraftLogbookMaintenanceOperationalRestrictionTable key={k} updated={self.props.updated} report_action={report_action} approveDeferredItem={self.props.approveDeferredItem}/>
              );
            })}
            </tbody>
          </table>
        </div>
        <hr/>
      </div>
    );
  }
}

export default AircraftLogbookMaintenanceOperationalRestrictionTab;



// WEBPACK FOOTER //
// ./src/Components/AircraftLogbooks/Elements/AircraftLogbookMaintenanceOperationalRestrictionTab.js